import axios from 'axios';
import {BaseResponse} from "../BaseResponse";

export async function deletePurchase(uid: string) {
    const response = await axios.delete<BaseResponse<boolean>>(`/purchase/${uid}`)

    return response.data
}

